export const localDev = false

export const filterPath = ['/visitor', '/app/personInfo', '/toLogin','/login','/installPersonList']



// WEBPACK FOOTER //
// ./src/utils/constant.js